<script>
import StrWorker from "@/components/StrWorker.vue";
import PaySectionSelection from "@/components/PaySectionSelection.vue";
import useSharedData from "@/use/SharedData.js";
import useSharedMethod from "@/use/SharedMethod.js";
import useTools from "@/use/Tools.js";
import {onMounted, ref} from "vue";
import {usePaySlipStore} from "@/stores/PaySlip";
import axios from "axios";

export default {
    props: {
        addAction: Boolean,
        deleteAction: Boolean,
    },
    components: {
        PaySectionSelection,
        StrWorker,
    },
    setup(props) {
        const {dialog, loading} = useSharedData();
        const {$route} = useTools();
        const {getBack, transformFilterValues} = useSharedMethod();
        const paySlipStore = usePaySlipStore();

        const data = ref({
            workers: [],
            filter: {},
        });
        const paySections = ref([]);
        const updateOption = ref('KEEP');

        const annex = ref({});

        function findAnnexById(id) {
            loading.value = true;
            axios.get(`/paySlipAnnexes/${id}`).then(response => {
                annex.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }

        function updatePaySection(items) {
            paySections.value = items;
        }

        function save() {
            loading.value = true;
            const ids = data.value.workers.map((w) => w.id);
            const body = {
                ids: ids,
                paySections: paySections.value,
                annexId: $route.params.annexId,
                updateOption: updateOption.value,
            };
            const url = props.addAction ? "addPaySections" : "deletePaySections";
            axios.put(`/payments/${url}/annex`, body, {
                params: transformFilterValues(data.value.filter),
            }).then(response => {
                paySlipStore.updateAll(response.data)
                getBack();
            }).finally(() => {
                loading.value = false;
            });
        }

        onMounted(() => findAnnexById($route.params.annexId))

        return {
            dialog,
            loading,
            data,
            paySections,
            updateOption,
            annex,
            getBack,
            updatePaySection,
            save,
        }
    },
}
</script>

<template>
    <v-dialog
        transition="dialog-bottom-transition"
        v-model="dialog"
        persistent
        max-width="1500"
        scrollable
    >
        <v-card flat>
            <w-toolbar
                v-if="addAction"
                color="teal"
                :title="`${$t('common.add_pay_sections')} (${annex.name})`"
            />
            <w-toolbar
                v-if="deleteAction"
                color="red"
                :title="`${$t('common.delete_pay_sections')} (${annex.name})`"
            />
            <v-card-text>
                <str-worker v-model="data" action="UPDATE_PAY_SLIP">
                    <pay-section-selection
                        :initial-pay-section-selection="paySections"
                        by-occupation
                        :pay-preview="false"
                        @updatePaySection="updatePaySection"
                    />
                </str-worker>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-radio-group
                    v-if="addAction"
                    v-model="updateOption"
                    class="mt-0"
                    row
                    hide-details
                >
                    <template v-slot:label>
                        {{ $t('pay_slip.if_pay_section_exist') }}
                    </template>
                    <v-radio value="KEEP" :label="$t('common.keep')" color="blue"></v-radio>
                    <v-radio value="ERASE" :label="$t('common.replace')" color="red"></v-radio>
                    <v-radio value="SUM" :label="$t('common.accumulate')" color="teal"></v-radio>
                </v-radio-group>
                <v-spacer/>
                <w-btn-close @press="getBack"/>
                <w-btn-add
                    :show="addAction"
                    :loadin="loading"
                    @press="save"
                />
                <w-btn-delete
                    :show="deleteAction"
                    :loading="loading"
                    @press="save"
                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>